/**
 * Al Manea Safety Program — Extended Warranty Terms & Conditions page content.
 *
 * Source of truth: Figma "Smart-tasks" file, frames node 129-5566..129-4669
 * (7 category tabs × EN/AR web). Content extracted verbatim from the design.
 *
 * ⚠️ KNOWN SOURCE ISSUES (flagged for BA — preserved verbatim per "copy exactly"):
 *   - mobiles_tablets: "Samrt Watches" sub-heading is a typo in the design.
 *   - tvs_audio: row-1 "Pro Combo (2 year)" price is locale-specific per design: EN 399 / AR 355.
 *   - AR "more info" button text is ABSENT in most AR frames; `moreInfoButton.ar`
 *     below is a placeholder pending official AR copy from BA.
 *
 * Rendered by: src/components/SafetyProgram/SafetyProgram.js
 * Reached via: /cms/al-manea-safety-program (special-cased in pages/cms/[cms_url].js)
 */

// Placeholder AR label for the bottom CTA (design omits it on AR frames). BA TODO.
const MORE_INFO_AR = "للمزيد من المعلومات حول الشروط والأحكام";

export const SAFETY_PROGRAM_TITLE = {
  en: "Terms and Conditions of the Warranty Program",
  ar: "شروط وأحكام برنامج الضمان",
};

export const SAFETY_PROGRAM_CATEGORIES = [
  {
    key: "mobiles_tablets",
    tab: { en: "Mobiles & Tablets", ar: "الجوالات والتابلت" },
    priceTables: [
      {
        subHeading: { en: "Mobile", ar: "الجوالات" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nAD (1 year)", ar: "ضمان ضد الكسر سنة\n(بلس)" },
          { en: "Pro\nAD (2 years)", ar: "ضمان ضد الكسر سنتين\n(برو)" },
          { en: "Elite\nCOMBO (3 years)", ar: "كومبو 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "799 – 3499", "250", "399", "649"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "3500 – 4499", "419", "619", "1600"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 – 7000", "490", "799", "2200"],
        ],
      },
      {
        subHeading: { en: "Tablet - Ipad", ar: "التابلت و الأيباد" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nAD (1 year)", ar: "ضمان ضد الكسر سنة\n(بلس)" },
          { en: "Pro\nAD (2 years)", ar: "ضمان ضد الكسر سنتين\n(برو)" },
          { en: "Elite\nCOMBO (3 years)", ar: "كومبو 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "799 – 1499", "152", "257", "450"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1500 – 2499", "238", "380", "799"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2500 – 3499", "333", "523", "1200"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "3500 – 4499", "409", "618", "1600"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 – 7200", "466", "850", "2200"],
        ],
      },
      {
        // NOTE: "Samrt Watches" is a typo in the source design (flagged for BA).
        subHeading: { en: "Samrt Watches", ar: "الساعات الذكية" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nAD (1 year)", ar: "ضمان ضد الكسر سنة\n(بلس)" },
          { en: "Pro\nAD (2 years)", ar: "ضمان ضد الكسر سنتين\n(برو)" },
          { en: "Elite\nCOMBO (3 years)", ar: "كومبو 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "799 – 1499", "152", "257", "361"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1500 – 2499", "238", "380", "523"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2500 – 3499", "333", "523", "713"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "3500 – 4499", "409", "618", "854"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 – 7000", "466", "760", "1044"],
        ],
      },
    ],
    comboNote: {
      en: "*The combo is a 3 years extended warranty + 3 years against extended damage",
      ar: "*الكومبو عباره عن 3 سنوات تمديد ضمان + 3 سنوات ضد الكسر",
    },
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        {
          title: { en: "Extended damage Protection Warranty:", ar: "ضمان ضد الكسر:" },
          body: {
            en: "This warranty protects your device from accidental damage such as drops, extended damage, or liquid spills, ensuring continuous service even in unexpected situations.",
            ar: "يحمي هذا الضمان جهازك من الأضرار العرضية غير المقصودة مثل السقوط أو الكسر،او السوائل لضمان استمرار الخدمة حتى في الظروف الطارئة.",
          },
        },
        {
          title: { en: "Home Repair Service:", ar: "خدمة إصلاح منزلية:" },
          body: {
            en: "A certified technician will visit your home, with an appointment scheduled within 48 hours, to repair your device without the need to visit a service center.",
            ar: "يقوم فني مختص بزيارة منزلك و سيتم تحديد وقت مناسب للزياره خلال 48 ساعة لإصلاح الجهاز دون الحاجة للذهاب إلى مركز الخدمة.",
          },
        },
        {
          title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" },
          body: {
            en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.",
            ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء.",
          },
        },
        {
          title: { en: "Guaranteed Repair or Replacement:", ar: "صيانة أو استبدال مضمون:" },
          body: {
            en: "In case of any device failure, we will provide you with a new device of the same or higher specifications, ensuring repair or replacement is done quickly and efficiently.\nThe warranty covers up to two repairs or replacements per year during the coverage period.",
            ar: "في حال حدوث أي عطل بجهازك، سنقوم بتزويدك بجهاز جديد بنفس المواصفات أو أعلى، مع ضمان إجراء الإصلاح أو الاستبدال بسرعة وكفاءة. يشمل الضمان ما يصل إلى مرتين إصلاح أو استبدال خلال كل عام من فترة التغطية.",
          },
        },
        {
          title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" },
          body: {
            en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.",
            ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة.",
          },
        },
        // AR Mobiles frame (node 129-2930) has this line; EN Mobiles frame omits it.
        // ⚠️ Confirm with BA whether EN Mobiles should also show it.
        { title: { en: null, ar: "بدأ من تاريخ شراء المنتج" }, body: { en: null, ar: null } },
      ],
    },
    repairFees: {
      heading: { en: "Repair and replacement fees", ar: "رسوم الإصلاح و الإستبدال" },
      columns: [
        { en: "Category", ar: "الفئات" },
        { en: "Repair fee", ar: "رسوم الإصلاح" },
        { en: "Replacement fee", ar: "رسوم التغيير" },
      ],
      rows: [
        [{ en: "Mobiles from 799 - 1499", ar: "الجوالات من 799 - 1499" }, "99", "199"],
        [{ en: "Mobile Phones", ar: "الجوالات" }, "199", "380"],
        [{ en: "Tablets", ar: "التابلت" }, "199", "300"],
        [{ en: "Samrt Watches", ar: "الساعات الذكية" }, "99", "199"],
      ],
    },
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "laptops",
    tab: { en: "Laptops", ar: "اللابتوب" },
    priceTables: [
      {
        subHeading: { en: "Laptops", ar: "اللابتوب" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nCOMBO (3 years)", ar: "كومبو 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "499 - 999", "109", "162", "299"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1000 - 1999", "219", "342", "599"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2000 - 3999", "409", "532", "1150"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4000 - 5999", "599", "854", "1840"],
        ],
      },
    ],
    comboNote: {
      en: "*The combo is a 3 years extended warranty + 3 years against breakage",
      ar: "*الكومبو عباره عن 3 سنوات تمديد ضمان + 3 سنوات ضد الكسر",
    },
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد الضمان المرن:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لمدة ثلاث أو أربع أو خمس سنوات إضافية ، مما يضمن راحة البال لفترة أطول." } },
        { title: { en: "Home Repair Service:", ar: "خدمة إصلاح منزلية:" }, body: { en: "A certified technician will visit your home, with an appointment scheduled within 48 hours, to repair your device without the need to visit a service center.", ar: "يقوم فني مختص بزيارة منزلك و سيتم تحديد وقت مناسب للزياره خلال 48 ساعة لإصلاح الجهاز دون الحاجة للذهاب إلى مركز الخدمة." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 30 days, we will replace it with a new device of equal or higher specifications.", ar: "إذا تعذر إصلاح الجهاز خلال 30 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة أو أعلى." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "استبدال عند تكرار الأعطال:" }, body: { en: "If the same problem occurs more than three times within one year, we will replace the device entirely", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل" } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Pixel Burn-In Coverage for Screens:", ar: "تغطية احتراق البكسلات للشاشات:" }, body: { en: "Coverage includes pixel burn-in issues in cameras and flat screens, according to manufacturer conditions.", ar: "تشمل التغطية مشاكل احتراق البكسلات في الكاميرات والشاشات المسطحة وفقًا لشروط المصنع." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        { title: { en: "Operating System Restoration:", ar: "استعادة نظام التشغيل:" }, body: { en: "In case of hard drive replacement, we will restore the original operating system on your new device.", ar: "عند استبدال القرص الصلب، نستعيد نظام التشغيل الأصلي على جهازك الجديد." } },
        // Standalone Medium-weight line, no body (Figma node 129-8491). ⚠️ AR text TODO from BA.
        { title: { en: "Effective from the Date of Product Purchase", ar: "بدأ من تاريخ شراء المنتج" }, body: { en: null, ar: null } },
        { title: { en: "Extended damage and Liquid Damage Protection Option:", ar: "خيار حماية ضد الكسر والسوائل:" }, body: { en: "An additional program that protects your device against extended damage or liquid damage for one or two years, with the option of repair or replacement for a fixed fee.", ar: "برنامج إضافي يحمي جهازك من الكسر أو السوائل لمدة سنة أو سنتين، مع إمكانية الإصلاح أو الاستبدال مقابل رسوم محددة." } },
      ],
    },
    repairFees: {
      heading: { en: "Repair and replacement fees", ar: "رسوم الإصلاح و الإستبدال" },
      columns: [
        { en: "Category", ar: "الفئات" },
        { en: "Repair fee", ar: "رسوم الإصلاح" },
        { en: "Replacement fee", ar: "رسوم التغيير" },
      ],
      rows: [[{ en: "Laptops", ar: "اللاب توب" }, "199", "300"]],
    },
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "tvs_audio",
    tab: { en: "TVs & Audio", ar: "شاشات وصوتيات" },
    priceTables: [
      {
        subHeading: { en: "TVs & Audio", ar: "شاشات وصوتيات" },
        comboFromCol: 5, // columns 5 & 6 (Plus/Pro Combo) get the navy tint per Figma
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "بلس\nتمديد ضمان (سنة)" },
          { en: "Pro\nEW (2 years)", ar: "برو\nتمديد ضمان (سنتين)" },
          { en: "Elite\nEW (3 years)", ar: "إيليت\nتمديد ضمان (3 سنوات)" },
          { en: "Plus\nCombo (1 year)", ar: "بلس\nكومبو (سنة)" },
          { en: "Pro\nCombo (2 year)", ar: "برو\nكومبو (سنتين)" },
        ],
        // row-1 "Pro Combo (2 year)" cell is locale-specific per design: EN 399, AR 355.
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "449 - 1099", "110", "165", "285", "205", { en: "399", ar: "355" }],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1100 - 2299", "219", "345", "475", "409", "725"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2300 - 4599", "409", "550", "779", "789", "1310"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4600 - 6699", "599", "879", "1099", "1169", "2019"],
        ],
      },
    ],
    comboNote: null, // moved into warrantyInclude as the final bullet (per Figma)
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد مرن للضمان:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لثلاث أو أربع أو خمس سنوات إضافية، لتضمن راحة البال لفترة اطول." } },
        { title: { en: "Home Repair Service by Certified Technician:", ar: "خدمة إصلاح منزلية عن طريق فني معتمد:" }, body: { en: "A qualified technician will visit your home, with an appointment scheduled within 48 hours, to repair your device without the need to visit a service center.", ar: "يقوم فني مختص بزيارة منزلك و سيتم تحديد وقت مناسب للزياره خلال 48 ساعة لإصلاح الجهاز دون الحاجة للذهاب إلى مركز الخدمة." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 14 days, we will replace it with a new one of similar specifications or compensate you with the product’s value.", ar: "إذا تعذر إصلاح الجهاز خلال 14 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة او تعويض بنفس القيمة للمنتج." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "إستبدال عند تكرار الأعطال:" }, body: { en: "If the same issue occurs more than three times within one year, we will replace the device entirely.", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل." } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Pixel Burn-In Coverage for Screens:", ar: "تغطية احتراق البكسلات للشاشات:" }, body: { en: "Coverage includes pixel burn-in issues in cameras and flat screens, according to manufacturer conditions.", ar: "تشمل التغطية مشاكل احتراق البكسلات في الكاميرات والشاشات المسطحة وفقًا لشروط المصنع." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures, starting from the original purchase date.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        { title: { en: "Extended damage and Liquid Damage Protection Option:", ar: "خيار حماية ضد الكسر والسوائل:" }, body: { en: "An additional program that protects your device against extended damage or liquid damage for one or two years, with the option of repair or replacement for a fixed fee.", ar: "برنامج إضافي يحمي جهازك من الكسر أو السوائل لمدة سنة أو سنتين، مع إمكانية الإصلاح أو الاستبدال مقابل رسوم محددة." } },
        // Per Figma this is the LAST bullet inside the warranty box (grey), not a blue footnote. ⚠️ AR text TODO from BA.
        { title: { en: "Replacement Fees for Almanea & LG Products (with Extended damage Protection):", ar: null }, body: { en: "A replacement fee of 475 SAR is applied once, after which the warranty ends.", ar: null } },
      ],
    },
    repairFees: {
      heading: { en: "Repair and replacement fees", ar: "رسوم الإصلاح و الإستبدال" },
      columns: [
        { en: "Category", ar: "الفئات" },
        { en: "Repair fee", ar: "رسوم الإصلاح" },
        { en: "Replacement fee", ar: "رسوم التغيير" },
      ],
      rows: [[{ en: "TVs", ar: "الشاشات" }, "199", "299"]],
    },
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "air_conditioners",
    tab: { en: "Air Conditioners", ar: "المكيفات" },
    priceTables: [
      {
        subHeading: { en: "Air Conditioners", ar: "مكيفات الهواء" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nEW (3 years)", ar: "تمديد ضمان 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "449 - 2299", "170", "239", "335"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2300 - 4499", "335", "495", "665"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 - 6599", "550", "759", "949"],
        ],
      },
    ],
    comboNote: null, // liquid-damage moved into warrantyInclude as an AR-only bullet (per Figma AC AR)
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد مرن للضمان:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لثلاث أو أربع أو خمس سنوات إضافية، لتضمن راحة البال لفترة اطول." } },
        { title: { en: "Home Repair Service by Certified Technician:", ar: "خدمة إصلاح منزلية عن طريق فني معتمد:" }, body: { en: "A qualified technician will visit your home, with an appointment scheduled within 48 hours, to repair your device without the need to visit a service center.", ar: "يقوم فني مختص بزيارة منزلك و سيتم تحديد وقت مناسب للزياره خلال 48 ساعة لإصلاح الجهاز دون الحاجة للذهاب إلى مركز الخدمة." } },
        { title: { en: "Quick Technician Visit:", ar: "زيارة سريعة لفني معتمد:" }, body: { en: "A certified technician will reach your location within a maximum of 48 hours from the time of service request.", ar: "يصل إليك فني متخصص خلال 48 ساعة كحد أقصى من لحظة طلب الخدمة." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 30 days, we will replace it with a new one of similar specifications or compensate you with the product’s value.", ar: "إذا تعذر إصلاح الجهاز خلال 30 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة او تعويض بنفس القيمة للمنتج." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "إستبدال عند تكرار الأعطال:" }, body: { en: "If the same issue occurs more than three times within one year, we will replace the device entirely.", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل." } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        // ⚠️ AC EN/AR asymmetry (per Figma): EN frame ends with "Effective…" (node 129-6927);
        // AR frame ends with the liquid-damage bullet (node 129-3752) — no "Effective…" in AR.
        // So each is locale-gated. Confirm with BA.
        { title: { en: "Effective from the Date of Product Purchase", ar: null }, body: { en: null, ar: null } },
        { title: { en: null, ar: "خيار حماية ضد الكسر والسوائل:" }, body: { en: null, ar: "برنامج إضافي يحمي جهازك من الكسر أو السوائل لمدة سنة أو سنتين، مع إمكانية الإصلاح أو الاستبدال مقابل رسوم محددة." } },
      ],
    },
    repairFees: null,
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "home_appliances",
    tab: { en: "Home Appliances", ar: "الأجهزة المنزلية" },
    priceTables: [
      {
        subHeading: { en: "Refrigerators & Freezers", ar: "الثلاجات والفريزرات" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nEW (3 years)", ar: "تمديد ضمان 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "449 - 2299", "170", "239", "335"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2300 - 4499", "335", "495", "665"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 - 6599", "550", "759", "949"],
        ],
      },
      {
        subHeading: { en: "Washing Machines & Dishwashers & Ovens", ar: "غسالات الملابس و الصحون و الافران" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nEW (3 years)", ar: "تمديد ضمان 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "449 - 2299", "260", "399", "499"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "2300 - 4499", "460", "699", "899"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "4500 - 6599", "699", "999", "1399"],
        ],
      },
    ],
    comboNote: null,
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد مرن للضمان:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لثلاث أو أربع أو خمس سنوات إضافية، لتضمن راحة البال لفترة اطول." } },
        { title: { en: "Home Repair Service by Certified Technician:", ar: "خدمة إصلاح منزلية عن طريق فني معتمد:" }, body: { en: "A qualified technician will visit your home, with an appointment scheduled within 48 hours, to repair your device without the need to visit a service center.", ar: "يقوم فني مختص بزيارة منزلك و سيتم تحديد وقت مناسب للزياره خلال 48 ساعة لإصلاح الجهاز دون الحاجة للذهاب إلى مركز الخدمة." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 30 days, we will replace it with a new one of similar specifications or compensate you with the product’s value.", ar: "إذا تعذر إصلاح الجهاز خلال 30 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة او تعويض بنفس القيمة للمنتج." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "إستبدال عند تكرار الأعطال:" }, body: { en: "If the same issue occurs more than three times within one year, we will replace the device entirely.", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل." } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        // Standalone Medium-weight line, no body (per Figma). ⚠️ AR text TODO from BA.
        { title: { en: "Effective from the Date of Product Purchase", ar: "بدأ من تاريخ شراء المنتج" }, body: { en: null, ar: null } },
      ],
    },
    repairFees: null,
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "small_appliances",
    tab: { en: "Small Appliances", ar: "الأجهزة المنزلية الصغيرة" },
    priceTables: [
      {
        subHeading: { en: "Small Appliances", ar: "الأجهزة المنزلية الصغيرة" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nEW (3 years)", ar: "تمديد ضمان 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "260 - 299", "67", "105", "124"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "400 - 599", "86", "135", "165"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "600 - 799", "105", "160", "200"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "800 - 999", "125", "190", "239"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1000 - 1199", "145", "219", "279"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1200 - 1399", "160", "249", "315"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1400 - 1599", "180", "279", "355"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1600 - 1799", "200", "305", "390"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1800 - 1999", "219", "335", "429"],
        ],
      },
    ],
    comboNote: null,
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد مرن للضمان:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لثلاث أو أربع أو خمس سنوات إضافية، لتضمن راحة البال لفترة اطول." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device's quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 30 days, we will replace it with a new one of similar specifications or compensate you with the product's value.", ar: "إذا تعذر إصلاح الجهاز خلال 30 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة او تعويض بنفس القيمة للمنتج." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "إستبدال عند تكرار الأعطال:" }, body: { en: "If the same issue occurs more than three times within one year, we will replace the device entirely.", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل." } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        // Design shows a trailing standalone line with no body:
        { title: { en: "Effective from the Date of Product Purchase", ar: "بدأ من تاريخ شراء المنتج" }, body: { en: null, ar: null } },
      ],
    },
    repairFees: null,
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },

  {
    key: "personal_care",
    tab: { en: "Personal care", ar: "العناية الشخصية" },
    priceTables: [
      {
        subHeading: { en: "Personal care", ar: "العناية الشخصية" },
        columns: [
          { en: "Service Name", ar: "اسم الخدمة" },
          { en: "Product Price Range", ar: "النطاق السعري للمنتج" },
          { en: "Plus\nEW (1 year)", ar: "تمديد ضمان سنة\n(بلس)" },
          { en: "Pro\nEW (2 years)", ar: "تمديد ضمان سنتين\n(برو)" },
          { en: "Elite\nEW (3 years)", ar: "تمديد ضمان 3 سنوات\n(إيليت)" },
        ],
        rows: [
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "260 - 299", "67", "105", "124"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "400 - 599", "86", "135", "165"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "600 - 799", "105", "160", "200"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "800 - 999", "125", "190", "239"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1000 - 1199", "145", "219", "279"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1200 - 1399", "160", "249", "315"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1400 - 1599", "180", "279", "355"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1600 - 1799", "200", "305", "390"],
          [{ en: "Almanea Protection", ar: "أمان المنيع" }, "1800 - 1999", "219", "335", "429"],
        ],
      },
    ],
    comboNote: null,
    warrantyInclude: {
      heading: { en: "General warranty include", ar: "الضمان العام يشمل" },
      items: [
        { title: { en: "Flexible Warranty Extension:", ar: "تمديد مرن للضمان:" }, body: { en: "You can choose to extend your warranty for an additional three, four, or five years, ensuring peace of mind for a longer period.", ar: "يمكنك اختيار تمديد الضمان لثلاث أو أربع أو خمس سنوات إضافية، لتضمن راحة البال لفترة اطول." } },
        { title: { en: "Guaranteed Original Spare Parts:", ar: "قطع غيار أصلية مضمونة:" }, body: { en: "We use only genuine spare parts to maintain your device’s quality and performance, just as it was at the time of purchase.", ar: "نستخدم فقط قطع غيار أصلية للحفاظ على جودة الجهاز وأدائه كما كان عند الشراء." } },
        { title: { en: "Repair or Replacement:", ar: "إصلاح أو استبدال:" }, body: { en: "If the device cannot be repaired within 30 days, we will replace it with a new one of similar specifications or compensate you with the product’s value.", ar: "إذا تعذر إصلاح الجهاز خلال 30 يومًا، نعوّضك بجهاز جديد بمواصفات مماثلة او تعويض بنفس القيمة للمنتج." } },
        { title: { en: "Replacement for Repeated Failures:", ar: "إستبدال عند تكرار الأعطال:" }, body: { en: "If the same issue occurs more than three times within one year, we will replace the device entirely.", ar: "إذا تكررت نفس المشكلة أكثر من ثلاث مرات خلال سنة واحدة، سنستبدل الجهاز بالكامل." } },
        { title: { en: "No Hidden Fees:", ar: "بدون رسوم خفية:" }, body: { en: "All labor and spare part costs are fully covered, with no additional undisclosed charges.", ar: "جميع تكاليف العمالة وقطع الغيار مغطاة بالكامل ولا توجد رسوم إضافية غير معلنة." } },
        { title: { en: "Transferable Warranty:", ar: "إمكانية نقل الضمان:" }, body: { en: "When selling the device, you can easily transfer the warranty to the new owner without complicated procedures.", ar: "عند بيع الجهاز، يمكنك نقل الضمان بسهولة إلى المالك الجديد دون إجراءات معقدة." } },
        // Standalone Medium-weight line, no body (per Figma). ⚠️ AR text TODO from BA.
        { title: { en: "Effective from the Date of Product Purchase", ar: "بدأ من تاريخ شراء المنتج" }, body: { en: null, ar: null } },
      ],
    },
    repairFees: null,
    moreInfoButton: { en: "For more information about terms and conditions", ar: MORE_INFO_AR },
  },
];
